import {
  ActivityIndicator,
  View,
} from 'react-native';

import * as _cr from "./_cr";
import { useLdrz } from "./_csLdr";

export const R = (pz: {
  children: React.FC,
}) => {
  const _sLdrz = useLdrz();
  return (
    _cr.c(View, {
      style: {
        width: '100%',
        height: '100%',
      }
    }, [

      pz.children,

      _sLdrz.crt.bShow ?
      _cr.c(View, {
        key: 'Ldr.root',
        style: { // backgroundColor で rgba を指定しない（StatusBarと色が異なってしまうため）
          height: '100%',
          width: '100%',
          position: 'absolute',
          zIndex: 99,
          top: 0,
          left: 0,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }, [ 
        _cr.c(ActivityIndicator, {
          key: -10,
          animating: true,
          color: '#C0C0C0',
          size: 100
        }),
      ])
      : undefined

    ])
  )

};
